export default "__VITE_ASSET__2LNou6ie__"